import type { MenuItem } from "../../../core/schema/MenuItem.js";

export function isMenuActive(menuItem: MenuItem, pageSlug: string): boolean {
	if (pageSlug === menuItem.path) {
		return true;
	}

	return (menuItem.submenus ?? []).some((submenu) => (submenu.items ?? []).some((s) => isMenuActive(s, pageSlug)));
}
